export default (value?: string) => {
    if(!value) {
        return ''
    }
    return value.replace(/(?:\r\n|\r|\n)/g, '<br />')
}